import { useState, useEffect } from "react";
import { toast } from "react-toastify";
import { useContextSelector } from "use-context-selector";
import { StateContext } from "../../contexts/StateContext";
import { chitOnboardByDateRange, joinMoneyChit } from "../../api/PupilApi";
import { useNavigate } from "react-router-dom";

const Chit = () => {
  const role = useContextSelector(StateContext, (state) => state.role);
  const userData = useContextSelector(StateContext, (state) => state.userData);

  const userEmail = useContextSelector(StateContext, (state) => {
    return (
      state.user?.email ||
      state.email ||
      state.pupilEmail ||
      state.userEmail ||
      null
    );
  });

  // ===== STATE =====
  const [chits, setChits] = useState([]);
  const [selectedChit, setSelectedChit] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  const navigate = useNavigate();

  const generalRulesList = [
    "Installments must be paid every month between the 1st and 5th.",
    "Upon completing 12 installments for a gold scheme, the specified benefit will be provided within 30 days.",
    "If a member discontinues a gold scheme, the total paid amount will be refunded after deducting one month's installment as a membership fee.",
    "Failure to pay two consecutive installments will result in disqualification from the scheme as per company policy.",
    "All gold provided is certified 916 KDM hallmark quality.",
  ];

  // Chit amount based descriptions
  const chitDescriptions = {
    50000: {
      title: "★ 50,000 சீட்டு – விதிமுறைகள் மற்றும் நிபந்தனைகள்",
      rules: [
        "முதல்சீட்டு : முதல் சீட்டு 'கம்பனிக்கு' வழங்கப்படும். முதல்மாதம் அனைவரும் ₹2,500 கட்ட வேண்டும்.",
        "₹50,000 சீட்டில் சேர்பவர்கள் :",
        "சீட்டு எடுக்காதவர்கள்: முதல்மாதம் ₹2,500 இருந்து கடைசி மாதம் வரை தொகை படிப்படியாக குறைந்து வரும்.",
        "சீட்டு எடுத்தவர்கள்: அனைத்து மாதங்களிலும் ₹3,000 கட்ட வேண்டும்.",
        "இந்த சீட்டு Fixed Chit ஆகும். அதனால் ஒவ்வொரு மாதத்திலும் முன்பாகவே அல்லது due date-க்கு முன் காலை 11 மணிக்குள் கட்டுதல் அவசியம்.",
        "★ அபராத விதிமுறைகள்",
        "காலதாமதம் செய்தால் :",
        "சீட்டு எடுத்தவர்கள் – ₹1,000 அபராதம்",
        "சீட்டு எடுக்காதவர்கள் – ₹500 அபராதம்",
        "குறிப்பு: இந்த அபராதம் லாப நோக்கத்திற்காக அல்ல. சீட்டு எடுக்கும் நபருக்கு, குறிக்கப்பட்ட நேரத்திற்குள் தொகை Settlement செய்ய வேண்டியது GVG Group of Companies-ன் நோக்கம்.",
        "★ சீட்டு பெற தேவையான ஆவணங்கள்",
        "மாதம் 1 முதல் 13 வரை (Early Chit Takers): சுதந்திரப் பதிவேடு (Mod Pathiram) சமர்ப்பிக்க வேண்டும் அல்லது அவர்களுடைய மற்ற சீட்டுகளை பிணையாக வைக்கலாம்.",
        "பிணையாக வைத்தால் 'எந்த மாதத்திலிருந்து பயன்படுத்தலாம்' என்பது ஒப்பந்தத்தில் தெளிவாக எழுதப்பட வேண்டும்.",
        "மாதம் 14 முதல் 21 வரை (Late Chit Takers): குடும்ப உறுப்பினரின் ஜாமீன் கட்டாயம். கீழ்க்கண்ட ஆவணங்கள் சமர்ப்பிக்க வேண்டும்: காசோலை (Cheque), PAN கார்டு நகல், ஆதார் நகல், புகைப்படம்",
        "★ முக்கிய அறிவிப்பு",
        "எங்கள் அலுவலகத்தின் gvggroupofcompanies.com இணையதளத்தில் உங்கள் அனைத்து தகவல்களும் பாதுகாப்பாக பதிவு செய்யப்பட்டுள்ளன. வாடிக்கையாளர்கள் தங்களுடைய தனிப்பட்ட தகவல்களை, சேர்ப்பு விவரங்களை, மற்றும் தொடர்புடைய அனைத்து ஆவணங்களையும் எங்கள் இணையதளத்தில் நேரடியாக பார்க்க முடியும்..."
      ]
    },
    100000: {
      title: "★ 1 லட்சம் சீட்டு – விதிமுறைகள் மற்றும் நிபந்தனைகள்",
      rules: [
        "முதல்சீட்டு : முதல் சீட்டு 'கம்பனிக்கு' வழங்கப்படும். முதல்மாதம் அனைவரும் ₹5,000 கட்ட வேண்டும்.",
        "₹1,00,000 சீட்டில் சேர்பவர்கள் :",
        "சீட்டு எடுக்காதவர்கள்: முதல்மாதம் ₹5,000 இருந்து கடைசி மாதம் வரை தொகை படிப்படியாக குறைந்து வரும்.",
        "சீட்டு எடுத்தவர்கள்: அனைத்து மாதங்களிலும் ₹6,000 கட்ட வேண்டும்.",
        "இந்த சீட்டு Fixed Chit ஆகும். அதனால் ஒவ்வொரு மாதத்திலும் முன்பாகவே அல்லது due date-க்கு முன் காலை 11 மணிக்குள் கட்டுதல் அவசியம்.",
        "★ அபராத விதிமுறைகள்",
        "காலதாமதம் செய்தால் :",
        "சீட்டு எடுத்தவர்கள் – ₹2,000 அபராதம்",
        "சீட்டு எடுக்காதவர்கள் – ₹1,000 அபராதம்",
        "குறிப்பு: இந்த அபராதம் லாப நோக்கத்திற்காக அல்ல. சீட்டு எடுக்கும் நபருக்கு, குறிக்கப்பட்ட நேரத்திற்குள் தொகை Settlement செய்ய வேண்டியது GVG Group of Companies-ன் நோக்கம்.",
        "★ சீட்டு பெற தேவையான ஆவணங்கள்",
        "மாதம் 1 முதல் 13 வரை (Early Chit Takers): சுதந்திரப் பதிவேடு (Mod Pathiram) சமர்ப்பிக்க வேண்டும் அல்லது அவர்களுடைய மற்ற சீட்டுகளை பிணையாக வைக்கலாம்.",
        "பிணையாக வைத்தால் 'எந்த மாதத்திலிருந்து பயன்படுத்தலாம்' என்பது ஒப்பந்தத்தில் தெளிவாக எழுதப்பட வேண்டும்.",
        "மாதம் 14 முதல் 21 வரை (Late Chit Takers): குடும்ப உறுப்பினரின் ஜாமீன் கட்டாயம். கீழ்க்கண்ட ஆவணங்கள் சமர்ப்பிக்க வேண்டும்: காசோலை (Cheque), PAN கார்டு நகல், ஆதார் நகல், புகைப்படம்",
        "★ முக்கிய அறிவிப்பு",
        "எங்கள் அலுவலகத்தின் gvggroupofcompanies.com இணையதளத்தில் உங்கள் அனைத்து தகவல்களும் பாதுகாப்பாக பதிவு செய்யப்பட்டுள்ளன. வாடிக்கையாளர்கள் தங்களுடைய தனிப்பட்ட தகவல்களை, சேர்ப்பு விவரங்களை, மற்றும் தொடர்புடைய அனைத்து ஆவணங்களையும் எங்கள் இணையதளத்தில் நேரடியாக பார்க்க முடியும்..."
      ]
    },
    200000: {
      title: "★ 2 லட்சம் சீட்டு – விதிமுறைகள் மற்றும் நிபந்தனைகள்",
      rules: [
        "முதல்சீட்டு : முதல் சீட்டு 'கம்பனிக்கு' வழங்கப்படும். முதல்மாதம் அனைவரும் ₹10,000 கட்ட வேண்டும்.",
        "₹2,00,000 சீட்டில் சேர்பவர்கள் :",
        "சீட்டு எடுக்காதவர்கள்: முதல்மாதம் ₹10,000 இருந்து கடைசி மாதம் வரை தொகை படிப்படியாக குறைந்து வரும்.",
        "சீட்டு எடுத்தவர்கள்: அனைத்து மாதங்களிலும் ₹12,000 கட்ட வேண்டும்.",
        "இந்த சீட்டு Fixed Chit ஆகும். அதனால் ஒவ்வொரு மாதத்திலும் முன்பாகவே அல்லது due date-க்கு முன் காலை 11 மணிக்குள் கட்டுதல் அவசியம்.",
        "★ அபராத விதிமுறைகள்",
        "காலதாமதம் செய்தால் :",
        "சீட்டு எடுத்தவர்கள் – ₹3,000 அபராதம்",
        "சீட்டு எடுக்காதவர்கள் – ₹1500 அபராதம்",
        "குறிப்பு: இந்த அபராதம் லாப நோக்கத்திற்காக அல்ல. சீட்டு எடுக்கும் நபருக்கு, குறிக்கப்பட்ட நேரத்திற்குள் தொகை Settlement செய்ய வேண்டியது GVG Group of Companies-ன் நோக்கம்.",
        "★ சீட்டு பெற தேவையான ஆவணங்கள்",
        "மாதம் 1 முதல் 13 வரை (Early Chit Takers): சுதந்திரப் பதிவேடு (Mod Pathiram) சமர்ப்பிக்க வேண்டும் அல்லது அவர்களுடைய மற்ற சீட்டுகளை பிணையாக வைக்கலாம்.",
        "பிணையாக வைத்தால் 'எந்த மாதத்திலிருந்து பயன்படுத்தலாம்' என்பது ஒப்பந்தத்தில் தெளிவாக எழுதப்பட வேண்டும்.",
        "மாதம் 14 முதல் 21 வரை (Late Chit Takers): குடும்ப உறுப்பினரின் ஜாமீன் கட்டாயம். கீழ்க்கண்ட ஆவணங்கள் சமர்ப்பிக்க வேண்டும்: காசோலை (Cheque), PAN கார்டு நகல், ஆதார் நகல், புகைப்படம்",
        "★ முக்கிய அறிவிப்பு",
        "எங்கள் அலுவலகத்தின் gvggroupofcompanies.com இணையதளத்தில் உங்கள் அனைத்து தகவல்களும் பாதுகாப்பாக பதிவு செய்யப்பட்டுள்ளன. வாடிக்கையாளர்கள் தங்களுடைய தனிப்பட்ட தகவல்களை, சேர்ப்பு விவரங்களை, மற்றும் தொடர்புடைய அனைத்து ஆவணங்களையும் எங்கள் இணையதளத்தில் நேரடியாக பார்க்க முடியும்..."
      ]
    },
    300000: {
      title: "★ 3 லட்சம் சீட்டு – விதிமுறைகள் மற்றும் நிபந்தனைகள்",
      rules: [
        "முதல்சீட்டு : முதல் சீட்டு 'கம்பனிக்கு' வழங்கப்படும். முதல்மாதம் அனைவரும் ₹15,000 கட்ட வேண்டும்.",
        "₹3,00,000 சீட்டில் சேர்பவர்கள் :",
        "சீட்டு எடுக்காதவர்கள்: முதல்மாதம் ₹15,000 இருந்து கடைசி மாதம் வரை தொகை படிப்படியாக குறைந்து வரும்.",
        "சீட்டு எடுத்தவர்கள்: அனைத்து மாதங்களிலும் ₹18,000 கட்ட வேண்டும்.",
        "இந்த சீட்டு Fixed Chit ஆகும். அதனால் ஒவ்வொரு மாதத்திலும் முன்பாகவே அல்லது due date-க்கு முன் காலை 11 மணிக்குள் கட்டுதல் அவசியம்.",
        "★ அபராத விதிமுறைகள்",
        "காலதாமதம் செய்தால் :",
        "சீட்டு எடுத்தவர்கள் – ₹4,000 அபராதம்",
        "சீட்டு எடுக்காதவர்கள் – ₹2,000 அபராதம்",
        "குறிப்பு: இந்த அபராதம் லாப நோக்கத்திற்காக அல்ல. சீட்டு எடுக்கும் நபருக்கு, குறிக்கப்பட்ட நேரத்திற்குள் தொகை Settlement செய்ய வேண்டியது GVG Group of Companies-ன் நோக்கம்.",
        "★ சீட்டு பெற தேவையான ஆவணங்கள்",
        "மாதம் 1 முதல் 13 வரை (Early Chit Takers): சுதந்திரப் பதிவேடு (Mod Pathiram) சமர்ப்பிக்க வேண்டும் அல்லது அவர்களுடைய மற்ற சீட்டுகளை பிணையாக வைக்கலாம்.",
        "பிணையாக வைத்தால் 'எந்த மாதத்திலிருந்து பயன்படுத்தலாம்' என்பது ஒப்பந்தத்தில் தெளிவாக எழுதப்பட வேண்டும்.",
        "மாதம் 14 முதல் 21 வரை (Late Chit Takers): குடும்ப உறுப்பினரின் ஜாமீன் கட்டாயம். கீழ்க்கண்ட ஆவணங்கள் சமர்ப்பிக்க வேண்டும்: காசோலை (Cheque), PAN கார்டு நகல், ஆதார் நகல், புகைப்படம்",
        "★ முக்கிய அறிவிப்பு",
        "எங்கள் அலுவலகத்தின் gvggroupofcompanies.com இணையதளத்தில் உங்கள் அனைத்து தகவல்களும் பாதுகாப்பாக பதிவு செய்யப்பட்டுள்ளன. வாடிக்கையாளர்கள் தங்களுடைய தனிப்பட்ட தகவல்களை, சேர்ப்பு விவரங்களை, மற்றும் தொடர்புடைய அனைத்து ஆவணங்களையும் எங்கள் இணையதளத்தில் நேரடியாக பார்க்க முடியும்..."
      ]
    },
    500000: {
      title: "★ 5 லட்சம் சீட்டு – விதிமுறைகள் மற்றும் நிபந்தனைகள்",
      rules: [
        "முதல்சீட்டு : முதல் சீட்டு 'கம்பனிக்கு' வழங்கப்படும். முதல்மாதம் அனைவரும் ₹25,000 கட்ட வேண்டும்.",
        "₹5,00,000 சீட்டில் சேர்பவர்கள் :",
        "சீட்டு எடுக்காதவர்கள்: முதல்மாதம் ₹25,000 இருந்து கடைசி மாதம் வரை தொகை படிப்படியாக குறைந்து வரும். இதற்கான விவரம் மேலே உள்ள அட்டவணையில் கொடுக்கப்பட்டுள்ளது.",
        "சீட்டு எடுத்தவர்கள்: அனைத்து மாதங்களிலும் ₹30,000 கட்ட வேண்டும்.",
        "இந்த சீட்டு Fixed Chit ஆகும். அதனால் ஒவ்வொரு மாதத்திலும் முன்பாகவே அல்லது due date-க்கு முன் காலை 11 மணிக்குள் கட்டுதல் அவசியம்.",
        "★ அபராத விதிமுறைகள்",
        "காலதாமதம் செய்தால் :",
        "சீட்டு எடுத்தவர்கள் – ₹5,000 அபராதம்",
        "சீட்டு எடுக்காதவர்கள் – ₹3,000 அபராதம்",
        "குறிப்பு: இந்த அபராதம் லாப நோக்கத்திற்காக அல்ல. சீட்டு எடுக்கும் நபருக்கு, குறிக்கப்பட்ட நேரத்திற்குள் தொகை Settlement செய்ய வேண்டியது GVG Group of Companies-ன் நோக்கம்.",
        "★ சீட்டு பெற தேவையான ஆவணங்கள்",
        "மாதம் 1 முதல் 13 வரை (Early Chit Takers): சுதந்திரப் பதிவேடு (Mod Pathiram) சமர்ப்பிக்க வேண்டும் அல்லது அவர்களுடைய மற்ற சீட்டுகளை பிணையாக வைக்கலாம்.",
        "பிணையாக வைத்தால் 'எந்த மாதத்திலிருந்து பயன்படுத்தலாம்' என்பது ஒப்பந்தத்தில் தெளிவாக எழுதப்பட வேண்டும்.",
        "மாதம் 14 முதல் 21 வரை (Late Chit Takers): குடும்ப உறுப்பினரின் ஜாமீன் கட்டாயம். கீழ்க்கண்ட ஆவணங்கள் சமர்ப்பிக்க வேண்டும்: காசோலை (Cheque), PAN கார்டு நகல், ஆதார் நகல், புகைப்படம்",
        "★ முக்கிய அறிவிப்பு",
        "எங்கள் அலுவலகத்தின் gvggroupofcompanies.com இணையதளத்தில் உங்கள் அனைத்து தகவல்களும் பாதுகாப்பாக பதிவு செய்யப்பட்டுள்ளன. வாடிக்கையாளர்கள் தங்களுடைய தனிப்பட்ட தகவல்களை, சேர்ப்பு விவரங்களை, மற்றும் தொடர்புடைய அனைத்து ஆவணங்களையும் எங்கள் இணையதளத்தில் நேரடியாக பார்க்க முடியும்..."
      ]
    },
    1000000: {
      title: "★ 10 லட்சம் சீட்டு – விதிமுறைகள் மற்றும் நிபந்தனைகள்",
      rules: [
        "முதல்சீட்டு : முதல் சீட்டு 'கம்பனிக்கு' வழங்கப்படும். முதல்மாதம் அனைவரும் ₹50,000 கட்ட வேண்டும்.",
        "₹10,00,000 சீட்டில் சேர்பவர்கள் :",
        "சீட்டு எடுக்காதவர்கள்: முதல்மாதம் ₹50,000 இருந்து கடைசி மாதம் வரை தொகை படிப்படியாக குறைந்து வரும். இதற்கான விவரம் மேலே உள்ள அட்டவணையில் கொடுக்கப்பட்டுள்ளது.",
        "சீட்டு எடுத்தவர்கள்: அனைத்து மாதங்களிலும் ₹60,000 கட்ட வேண்டும்.",
        "இந்த சீட்டு Fixed Chit ஆகும். அதனால் ஒவ்வொரு மாதத்திலும் முன்பாகவே அல்லது due date-க்கு முன் காலை 11 மணிக்குள் கட்டுதல் அவசியம்.",
        "★ அபராத விதிமுறைகள்",
        "காலதாமதம் செய்தால் :",
        "சீட்டு எடுத்தவர்கள் – ₹10,000 அபராதம்",
        "சீட்டு எடுக்காதவர்கள் – ₹6,000 அபராதம்",
        "குறிப்பு: இந்த அபராதம் லாப நோக்கத்திற்காக அல்ல. சீட்டு எடுக்கும் நபருக்கு, குறிக்கப்பட்ட நேரத்திற்குள் தொகை Settlement செய்ய வேண்டியது GVG Group of Companies-ன் நோக்கம்.",
        "★ சீட்டு பெற தேவையான ஆவணங்கள்",
        "மாதம் 1 முதல் 13 வரை (Early Chit Takers): சுதந்திரப் பதிவேடு (Mod Pathiram) சமர்ப்பிக்க வேண்டும் அல்லது அவர்களுடைய மற்ற சீட்டுகளை பிணையாக வைக்கலாம்.",
        "பிணையாக வைத்தால் 'எந்த மாதத்திலிருந்து பயன்படுத்தலாம்' என்பது ஒப்பந்தத்தில் தெளிவாக எழுதப்பட வேண்டும்.",
        "மாதம் 14 முதல் 21 வரை (Late Chit Takers): குடும்ப உறுப்பினரின் ஜாமீன் கட்டாயம். கீழ்க்கண்ட ஆவணங்கள் சமர்ப்பிக்க வேண்டும்: காசோலை (Cheque), PAN கார்டு நகல், ஆதார் நகல், புகைப்படம்",
        "★ முக்கிய அறிவிப்பு",
        "எங்கள் அலுவலகத்தின் gvggroupofcompanies.com இணையதளத்தில் உங்கள் அனைத்து தகவல்களும் பாதுகாப்பாக பதிவு செய்யப்பட்டுள்ளன. வாடிக்கையாளர்கள் தங்களுடைய தனிப்பட்ட தகவல்களை, சேர்ப்பு விவரங்களை, மற்றும் தொடர்புடைய அனைத்து ஆவணங்களையும் எங்கள் இணையதளத்தில் நேரடியாக பார்க்க முடியும்..."
      ]
    }
  };

  // Get chit description based on amount
  const getChitDescription = (chitAmount) => {
    const amount = parseInt(chitAmount);
    
    // Find the closest matching amount
    const amounts = Object.keys(chitDescriptions).map(Number).sort((a, b) => a - b);
    const matchingAmount = amounts.find(a => a === amount) || 
                         amounts.find(a => a > amount) || 
                         amounts[amounts.length - 1];
    
    return chitDescriptions[matchingAmount] || chitDescriptions[500000];
  };

  // Calculate total amount based on your specific formula
  const calculateTotalAmount = (scheduleData, currentMonth, totalMembers) => {
    if (currentMonth === 1) {
      return 0;
    }

    // Sum of non-settled amounts from previous months (fullNonChit)
    let nonSettledSum = 0;
    for (let i = 0; i < currentMonth - 1; i++) {
      nonSettledSum += scheduleData[i].fullNonChit || 0;
    }

    // Calculate settled amount for remaining months (fullChit * remaining months)
    const remainingMonths = totalMembers - currentMonth;
    const settledAmount = (scheduleData[currentMonth - 1].fullChit || 0) * remainingMonths;

    return nonSettledSum + settledAmount;
  };

  // === API CALL FUNCTION ===
  const fetchChits = async (start, end) => {
    setIsLoading(true);
    try {
      const res = await chitOnboardByDateRange(start, end, "chit");

      let chitsData = [];
      console.log("full data is here :", res.data);

      if (Array.isArray(res.data)) {
        chitsData = res.data.map((item) => {
          // If chitData exists, spread it and add the other properties
          if (item.chitData) {
            return {
              ...item.chitData, // This includes chitMemberList
              category: item.category,
              createdAt: item.createdAt,
              name: item.name,
              pupilEmail: item.pupilEmail,
              // chitMemberList is already included in item.chitData
            };
          } else {
            return item;
          }
        });
      } else {
        // Handle single object response
        if (res.data.chitData) {
          chitsData = [{
            ...res.data.chitData,
            category: res.data.category,
            createdAt: res.data.createdAt,
            name: res.data.name,
            pupilEmail: res.data.pupilEmail,
          }];
        } else {
          chitsData = [res.data];
        }
      }
      
      console.log("Processed chits data:", chitsData); // Debug log
      setChits(chitsData);

    } catch (err) {
      toast.error("Error fetching chit data: " + err.message);
      console.error("Error details:", err);
    } finally {
      setIsLoading(false);
    }
  };

  const handleViewDetails = (chit) => {
    setSelectedChit(chit);
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setSelectedChit(null);
  };

  const formatDisplayDate = (dateString) => {
    const options = { year: "numeric", month: "short", day: "numeric" };
    return new Date(dateString).toLocaleDateString(undefined, options);
  };

  const handleOnboardUserDataIntoChit = async () => {
    // === SIGNUP / LOGIN CHECK ===
    const storageEmail =
      localStorage.getItem("email") ||
      localStorage.getItem("pupilEmail") ||
      localStorage.getItem("userEmail") ||
      null;

    const token =
      localStorage.getItem("token") ||
      localStorage.getItem("authToken") ||
      null;

    const isSignedIn =
      Boolean(userEmail) || Boolean(storageEmail) || Boolean(role) || Boolean(token);

    if (!isSignedIn) {
      toast.info("Please sign up or log in to join this chit.");
      navigate("/signup");
      return;
    }

    if (!selectedChit) {
      toast.warning("Please select a chit before proceeding.");
      return;
    }

    try {
      const payload = {
        category: selectedChit.category,
        chitTitle: selectedChit.chitTitle,
        chitValue: selectedChit.chitValue,
        chitMemberList: selectedChit.chitMemberList || [],
        createdAt: selectedChit.createdAt,
        startDate: selectedChit.startDate,
        endDate: selectedChit.endDate,
        name: selectedChit.name,
        pupilEmail: selectedChit.pupilEmail,
        members: selectedChit.members,
        months: selectedChit.months,
        monthlyDecrease: selectedChit.monthlyDecrease,
        fullChitBidderAmount: selectedChit.fullChitBidderAmount,
        startFullChitNonBidder: selectedChit.startFullChitNonBidder,
        scheduleData: selectedChit.scheduleData || [],
        totalPaid: selectedChit.totalPaid || 0,
        totalGoldCollected: selectedChit.totalGoldCollected || 0,
        joined: true,
      };

      console.log("Joining chit with payload:", payload);
      const response = await joinMoneyChit(payload);

      toast.success("Successfully joined the chit!");
      console.log("Join chit response:", response.data);

      handleCloseModal();
      setChits((prev) =>
        prev.map((c) =>
          c.chitId === selectedChit.chitId ? { ...c, joined: true } : c
        )
      );
    } catch (error) {
      toast.error(
        "Failed to join chit: " + (error.response?.data || error.message)
      );
      console.error("Error joining chit:", error);
    }
  };

  useEffect(() => {
    const currentYear = new Date().getFullYear();
    const defaultStart = `${currentYear}-01-01`;
    const defaultEnd = `${currentYear}-12-31`;

    if (!startDate.trim() && !endDate.trim()) {
      fetchChits(defaultStart, defaultEnd);
    } else {
      fetchChits(startDate, endDate);
    }
  }, [startDate, endDate]);

  const handleFetchClick = () => {
    if (!startDate || !endDate) {
      toast.error("Please select both Start Date and End Date");
      return;
    }
    fetchChits(startDate, endDate);
  };

  const handleBack = () => {
    navigate("/");
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-amber-50 via-white to-amber-50 py-8 px-4 sm:px-6 lg:px-8 font-sans">
      <div className="max-w-7xl mx-auto">
        {/* Hero Section */}
        <div className="text-center mb-12">
          <div className="bg-gradient-to-r from-green-500 to-green-600 rounded-3xl p-8 sm:p-12 shadow-2xl mb-8 relative overflow-hidden">
            <div className="absolute inset-0 bg-black opacity-5"></div>
            <div className="relative">
              <h1 className="text-4xl sm:text-5xl md:text-6xl font-bold text-white mb-4 drop-shadow-lg">
                Smart Chit Fund <span className="text-yellow-300">Schemes</span>
              </h1>
              <p className="text-xl text-amber-100 max-w-3xl mx-auto leading-relaxed">
                Secure your financial future with our trusted Gold and Money Chit plans.
                Discover flexible schemes tailored to help you achieve your dreams.
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 -mt-8">
        {/* Filter Card */}
        <div className="bg-white/90 backdrop-blur-lg rounded-xl shadow-lg border border-white/20 p-4 sm:p-6 mb-8">
            <div className="flex flex-col items-center gap-4">
              <div className="text-center w-full">
                <h2 className="text-lg sm:text-xl font-bold text-gray-800 mb-1">Find Your Perfect Chit</h2>
                <p className="text-xs sm:text-sm text-gray-600">Filter available schemes by date range</p>
              </div>

              <div className="w-full space-y-3">
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                  <div className="w-full">
                    <label className="block text-xs font-semibold text-gray-700 mb-1">Start Date</label>
                    <input
                      type="date"
                      value={startDate}
                      onChange={(e) => setStartDate(e.target.value)}
                      className="w-full px-3 py-2.5 text-sm rounded-lg border border-gray-200 focus:border-blue-500 focus:ring-2 focus:ring-blue-200 transition-all duration-300"
                    />
                  </div>
                  <div className="w-full">
                    <label className="block text-xs font-semibold text-gray-700 mb-1">End Date</label>
                    <input
                      type="date"
                      value={endDate}
                      onChange={(e) => setEndDate(e.target.value)}
                      className="w-full px-3 py-2.5 text-sm rounded-lg border border-gray-200 focus:border-blue-500 focus:ring-2 focus:ring-blue-200 transition-all duration-300"
                    />
                  </div>
                </div>

                <button
                  onClick={handleFetchClick}
                  disabled={isLoading}
                  className="w-full px-4 py-3 bg-gradient-to-r from-green-600 to-green-600 text-white rounded-lg font-semibold hover:from-green-700 hover:to-green-700 transition-all duration-300 shadow-lg hover:shadow-xl transform hover:-translate-y-0.5 flex items-center justify-center gap-2 text-sm disabled:opacity-50 disabled:cursor-not-allowed disabled:transform-none"
                >
                  {isLoading ? (
                    <>
                      <div className="w-4 h-4 border-2 border-white/30 border-t-white rounded-full animate-spin"></div>
                      Searching...
                    </>
                  ) : (
                    <>
                      <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                      </svg>
                      Find Schemes
                    </>
                  )}
                </button>
              </div>
            </div>
          </div>
        {/* Chits Grid Section */}
        <section className="mb-16">
          <div className="flex flex-col sm:flex-row justify-between items-center mb-8">
            <div>
              <h2 className="text-3xl font-bold text-gray-800 mb-2">Available Chit Schemes</h2>
              <p className="text-gray-600">Browse and join schemes that match your financial goals</p>
            </div>
            <span className="px-4 py-2 bg-green-100 text-gray-800 rounded-full font-semibold text-sm mt-4 sm:mt-0">
              {chits.length} {chits.length === 1 ? 'Scheme' : 'Schemes'} Available
            </span>
          </div>

          {chits.length === 0 && !isLoading ? (
            <div className="text-center py-16 bg-white/50 rounded-2xl backdrop-blur-sm border border-gray-100">
              <div className="w-24 h-24 mx-auto mb-6 bg-gradient-to-br from-blue-100 to-purple-100 rounded-full flex items-center justify-center">
                <svg className="w-12 h-12 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1} d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" />
                </svg>
              </div>
              <h3 className="text-xl font-semibold text-gray-700 mb-2">No chit schemes available</h3>
              <p className="text-gray-500 max-w-md mx-auto">
                Try adjusting your date range or check back later for new investment opportunities.
              </p>
            </div>
          ) : (
            <div className="grid gap-8 grid-cols-1 md:grid-cols-2 xl:grid-cols-3">
              {chits?.map((chit, index) => (
                <div
                  key={index}
                  className="group bg-white rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-500 overflow-hidden border border-gray-100 hover:border-blue-200 transform hover:-translate-y-2"
                >
                  {/* Card Header with Gradient */}
                  <div className="relative bg-gradient-to-r from-green-500 via-green-600 to-green-700 p-6 text-white overflow-hidden">
                    <div className="absolute inset-0 bg-gradient-to-r from-white/10 to-transparent"></div>
                    <div className="relative z-10">
                      <div className="flex justify-between items-start mb-3">
                        <h3 className="text-xl font-bold truncate pr-2">{chit.chitTitle}</h3>
                        <span className="bg-white/20 backdrop-blur-sm px-3 py-1 rounded-full text-xs font-semibold whitespace-nowrap">
                          {chit.category || 'Premium'}
                        </span>
                      </div>
                      <p className="text-2xl font-bold text-yellow-300">
                        ₹{chit.chitValue?.toLocaleString('en-IN')}
                      </p>
                    </div>
                  </div>

                  {/* Card Content */}
                  <div className="p-6">
                    {/* Date Badges */}
                    <div className="flex gap-3 mb-6">
                      <div className="flex-1 bg-gradient-to-br from-green-50 to-emerald-50 p-3 rounded-xl border border-green-100 text-center">
                        <p className="text-xs text-green-600 font-semibold mb-1">START DATE</p>
                        <p className="text-sm font-bold text-gray-800">{formatDisplayDate(chit.startDate)}</p>
                      </div>
                      <div className="flex-1 bg-gradient-to-br from-orange-50 to-red-50 p-3 rounded-xl border border-orange-100 text-center">
                        <p className="text-xs text-red-600 font-semibold mb-1">END DATE</p>
                        <p className="text-sm font-bold text-gray-800">{formatDisplayDate(chit.endDate)}</p>
                      </div>
                    </div>

                    {/* Stats Grid */}
                    <div className="grid grid-cols-2 gap-4 mb-6">
                      <div className="text-center p-3 bg-blue-50 rounded-lg">
                        <p className="text-2xl font-bold text-green-600">{chit.members}</p>
                        <p className="text-xs text-green-800 font-semibold">TOTAL MEMBERS</p>
                      </div>
                      <div className="text-center p-3 bg-purple-50 rounded-lg">
                        <p className="text-2xl font-bold text-green-600">{chit.months}</p>
                        <p className="text-xs text-green-800 font-semibold">MONTHS</p>
                      </div>
                      <div className="text-center p-3 bg-green-50 rounded-lg col-span-2">
                        <p className="text-2xl font-bold text-green-600">
                          {Array.isArray(chit.chitMemberList) ? chit.chitMemberList.length : 0}
                        </p>
                        <p className="text-xs text-green-800 font-semibold">JOINED MEMBERS</p>
                      </div>
                    </div>

                    {/* Monthly Payment */}
                    {chit.monthlyDecrease && (
                      <div className="mb-6 p-4 bg-gradient-to-r from-yellow-50 to-amber-50 rounded-xl border border-yellow-100">
                        <p className="text-sm text-amber-800 font-semibold mb-1">Monthly Payment</p>
                        <p className="text-xl font-bold text-amber-900">
                          ₹{chit.startFullChitNonBidder?.toLocaleString('en-IN') || '0'}
                        </p>
                      </div>
                    )}

                    {/* Action Button */}
                    <button
                      onClick={() => handleViewDetails(chit)}
                      className="w-full py-3 px-4 bg-gradient-to-r from-green-600 to-green-600 text-white rounded-xl font-semibold hover:from-green-700 hover:to-green-700 transition-all duration-300 transform hover:scale-105 shadow-md hover:shadow-lg flex items-center justify-center gap-2"
                    >
                      <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                      </svg>
                      View Scheme Details
                    </button>
                  </div>
                </div>
              ))}
            </div>
          )}
        </section>

        {/* Chit Details Modal */}
        {isModalOpen && selectedChit && (
          <div className="fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center p-4 z-50 animate-fadeIn">
            <div className="bg-white rounded-3xl shadow-2xl w-full max-w-6xl max-h-[95vh] overflow-hidden transform animate-scaleIn">
              {/* Modal Header */}
              <div className="relative bg-gradient-to-r from-green-600 to-green-700 p-8 text-white">
                <div className="absolute inset-0 bg-gradient-to-r from-white/10 to-transparent"></div>
                <div className="relative z-10">
                  <div className="flex justify-between items-start">
                    <div className="pr-8">
                      <h2 className="text-3xl font-bold mb-2">{selectedChit.chitTitle}</h2>
                      <p className="text-blue-100 text-lg">
                        Total Value: <span className="font-bold text-yellow-300">₹{selectedChit.chitValue?.toLocaleString('en-IN')}</span>
                      </p>
                    </div>
                    <button
                      onClick={handleCloseModal}
                      className="text-white hover:text-yellow-200 text-3xl transition-transform duration-300 hover:scale-110 bg-white/20 p-2 rounded-full"
                    >
                      &times;
                    </button>
                  </div>
                </div>
              </div>

              {/* Modal Content */}
              <div className="p-8 max-h-[60vh] overflow-y-auto">
                {/* Key Metrics */}
                <div className="grid grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
                  {[
                    { label: "Start Date", value: formatDisplayDate(selectedChit.startDate), icon: "📅", color: "green" },
                    { label: "End Date", value: formatDisplayDate(selectedChit.endDate), icon: "🎯", color: "red" },
                    { label: "Total Members", value: selectedChit.members, icon: "👥", color: "blue" },
                    { label: "Duration", value: `${selectedChit.months} Months`, icon: "⏳", color: "purple" },
                  ].map((item, index) => (
                    <div key={index} className={`bg-gradient-to-br from-${item.color}-50 to-${item.color}-100 p-4 rounded-2xl border border-${item.color}-200 text-center`}>
                      <div className="text-2xl mb-2">{item.icon}</div>
                      <p className="text-sm font-semibold text-gray-600 mb-1">{item.label}</p>
                      <p className="text-lg font-bold text-gray-800">{item.value}</p>
                    </div>
                  ))}
                </div>

                {/* Payment Information */}
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mb-8">
                  <div className="bg-gradient-to-br from-emerald-50 to-green-100 p-6 rounded-2xl border border-green-200">
                    <h3 className="text-lg font-bold text-green-800 mb-3 flex items-center gap-2">
                      <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
                        <path fillRule="evenodd" d="M4 4a2 2 0 00-2 2v4a2 2 0 002 2V6h10a2 2 0 00-2-2H4zm2 6a2 2 0 012-2h8a2 2 0 012 2v4a2 2 0 01-2 2H8a2 2 0 01-2-2v-4zm6 4a2 2 0 100-4 2 2 0 000 4z" clipRule="evenodd" />
                      </svg>
                      Monthly Payment
                    </h3>
                    <p className="text-3xl font-bold text-green-900">
                      ₹{selectedChit.startFullChitNonBidder?.toLocaleString('en-IN') || '0'}
                    </p>
                  </div>

                  <div className="bg-gradient-to-br from-amber-50 to-orange-100 p-6 rounded-2xl border border-amber-200">
                    <h3 className="text-lg font-bold text-amber-800 mb-3 flex items-center gap-2">
                      <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
                        <path d="M8.433 7.418c.155-.103.346-.267v1.698a2.305 2.305 0 01-.567-.267C8.07 8.34 8 8.114 8 8c0-.114.07-.34.433-.582zM11 12.849v-1.698c.22.071.412.164.567.267.364.243.433.468.433.582 0 .114-.07.34-.433.582a2.305 2.305 0 01-.567.267z" />
                        <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-13a1 1 0 10-2 0v.092a4.535 4.535 0 00-1.676.662C6.602 6.234 6 7.009 6 8c0 .99.602 1.765 1.324 2.246.48.32 1.054.545 1.676.662v1.941c-.391-.127-.68-.317-.843-.504a1 1 0 10-1.51 1.31c.562.649 1.413 1.076 2.353 1.253V15a1 1 0 102 0v-.092a4.535 4.535 0 001.676-.662C13.398 13.766 14 12.991 14 12c0-.99-.602-1.765-1.324-2.246A4.535 4.535 0 0011 9.092V7.151c.391.127.68.317.843.504a1 1 0 101.511-1.31c-.563-.649-1.413-1.076-2.354-1.253V5z" clipRule="evenodd" />
                      </svg>
                      Payment Details
                    </h3>
                    <div className="space-y-2">
                      <p className="text-sm text-amber-700">
                        <span className="font-semibold">Settled Member:</span> ₹{selectedChit.fullChitBidderAmount?.toLocaleString('en-IN') || 'N/A'}
                      </p>
                      <p className="text-sm text-amber-700">
                        <span className="font-semibold">Non-Settled Member:</span> ₹{selectedChit.startFullChitNonBidder?.toLocaleString('en-IN') || 'N/A'}
                      </p>
                    </div>
                  </div>
                </div>

                {/* Schedule Table */}
                {selectedChit.scheduleData && selectedChit.scheduleData.length > 0 && (
                  <div className="mb-8">
                    <h3 className="text-xl font-bold text-gray-800 mb-4 flex items-center gap-2">
                      <svg className="w-5 h-5 text-blue-600" fill="currentColor" viewBox="0 0 20 20">
                        <path fillRule="evenodd" d="M6 2a1 1 0 00-1 1v1H4a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-1V3a1 1 0 10-2 0v1H7V3a1 1 0 00-1-1zm0 5a1 1 0 000 2h8a1 1 0 100-2H6z" clipRule="evenodd" />
                      </svg>
                      Payment Schedule
                    </h3>
                    <div className="overflow-hidden rounded-2xl border border-gray-200 shadow-sm">
                      <table className="min-w-full divide-y divide-gray-200">
                        <thead className="bg-gradient-to-r from-gray-50 to-gray-100">
                          <tr>
                            {['Month', 'Non-Settled Member', 'Settled Member', 'Total Amount'].map((header, idx) => (
                              <th key={idx} className="px-6 py-4 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider">
                                {header}
                              </th>
                            ))}
                          </tr>
                        </thead>
                        <tbody className="bg-white divide-y divide-gray-200">
                          {selectedChit.scheduleData.map((data, index) => {
                            const totalAmount = calculateTotalAmount(
                              selectedChit.scheduleData, 
                              data.month, 
                              selectedChit.members
                            );

                            return (
                              <tr key={index} className="hover:bg-gray-50 transition-colors duration-200">
                                <td className="px-6 py-4 whitespace-nowrap text-sm font-semibold text-gray-900">
                                  {data.month}
                                </td>
                                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-600">
                                  {data.fullNonChit ? `₹${data.fullNonChit.toLocaleString('en-IN')}` : "-"}
                                </td>
                                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-600">
                                  {data.fullChit ? `₹${data.fullChit.toLocaleString('en-IN')}` : "-"}
                                </td>
                                <td className="px-6 py-4 whitespace-nowrap text-sm font-semibold text-green-700">
                                  ₹{totalAmount.toLocaleString('en-IN')}
                                </td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    </div>
                  </div>
                )}

                {/* Chit Description Section */}
                <div className="mb-8">
                  <h3 className="text-xl font-bold text-gray-800 mb-4 flex items-center gap-2">
                    <svg className="w-5 h-5 text-red-600" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd" />
                    </svg>
                    Scheme Rules & Guidelines
                  </h3>
                  <div className="bg-gradient-to-r from-red-50 to-orange-100 rounded-2xl p-6 border border-red-200">
                    {(() => {
                      const description = getChitDescription(selectedChit.chitValue);
                      return (
                        <>
                          <h4 className="text-lg font-bold text-red-800 mb-4">{description.title}</h4>
                          <div className="space-y-3">
                            {description.rules.map((rule, index) => (
                              <div key={index} className="flex items-start gap-3">
                                <div className="w-2 h-2 bg-red-500 rounded-full mt-2 flex-shrink-0"></div>
                                <p className="text-red-900 leading-relaxed text-sm">{rule}</p>
                              </div>
                            ))}
                          </div>
                        </>
                      );
                    })()}
                  </div>
                </div>

                {/* Chit Members List - FIXED MAPPING */}
                {selectedChit.chitMemberList && Array.isArray(selectedChit.chitMemberList) && selectedChit.chitMemberList.length > 0 ? (
                  <div className="mb-8">
                    <h3 className="text-xl font-bold text-gray-800 mb-4 flex items-center gap-2">
                      <svg className="w-5 h-5 text-green-600" fill="currentColor" viewBox="0 0 20 20">
                        <path fillRule="evenodd" d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z" clipRule="evenodd" />
                      </svg>
                      Chit Members ({selectedChit.chitMemberList.length})
                    </h3>
                    <div className="grid gap-3">
                      {selectedChit.chitMemberList.map((member, index) => (
                        <div key={index} className="flex items-center justify-between p-4 bg-gradient-to-r from-gray-50 to-gray-100 rounded-xl border border-gray-200">
                          <div className="flex items-center gap-3">
                            <div className="w-10 h-10 bg-gradient-to-br from-green-500 to-green-600 rounded-full flex items-center justify-center text-white font-bold">
                              {member.name ? member.name.charAt(0).toUpperCase() : 'U'}
                            </div>
                            <div>
                              <p className="font-semibold text-gray-800">{member.name || 'Unknown Member'}</p>
                              <p className="text-sm text-gray-600">{member.pupilEmail || member.email || 'No email provided'}</p>
                              {member.mobileNumber && (
                                <p className="text-sm text-gray-500">{member.mobileNumber}</p>
                              )}
                            </div>
                          </div>
                          <span className="px-3 py-1 bg-green-100 text-green-800 text-xs font-medium rounded-full">
                            Member
                          </span>
                        </div>
                      ))}
                    </div>
                  </div>
                ) : (
                  /* Show message if no members have joined yet */
                  <div className="mb-8 text-center py-8 bg-gray-50 rounded-2xl">
                    <svg className="w-12 h-12 text-gray-400 mx-auto mb-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
                    </svg>
                    <h4 className="text-lg font-semibold text-gray-700 mb-2">No Members Yet</h4>
                    <p className="text-gray-500">Be the first to join this chit scheme!</p>
                  </div>
                )}
              </div>

              {/* Modal Footer */}
              <div className="bg-gray-50 p-6 border-t border-gray-200 flex flex-col sm:flex-row gap-4 justify-between items-center">
                <button
                  onClick={handleCloseModal}
                  className="w-full sm:w-auto px-8 py-3 bg-white text-gray-700 rounded-xl font-semibold hover:bg-gray-100 transition-all duration-300 border border-gray-300 hover:border-gray-400"
                >
                  Close Details
                </button>
                <button
                  onClick={handleOnboardUserDataIntoChit}
                  className="w-full sm:w-auto px-8 py-3 bg-gradient-to-r from-green-500 to-emerald-600 text-white rounded-xl font-semibold hover:from-green-600 hover:to-emerald-700 transition-all duration-300 shadow-lg hover:shadow-xl transform hover:scale-105 flex items-center justify-center gap-2"
                >
                  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
                  </svg>
                  Join This Chit Scheme
                </button>
              </div>
            </div>
          </div>
        )}

        {/* Rules Section */}
                {/* Rules Section */}
        <section className="mt-16">
          <div className="bg-white rounded-2xl shadow-lg p-8">
            <h2 className="text-3xl font-bold text-gray-800 mb-8 text-center">All Chit Scheme Rules & Guidelines</h2>
            
            <div className="space-y-8">
              {Object.entries(chitDescriptions).map(([amount, description]) => (
                <div key={amount} className="bg-gradient-to-r from-red-50 to-orange-100 rounded-2xl p-6 border border-red-200">
                  <h3 className="text-xl font-bold text-red-800 mb-4">{description.title}</h3>
                  <div className="space-y-3">
                    {description.rules.map((rule, index) => (
                      <div key={index} className="flex items-start gap-3">
                        <div className="w-2 h-2 bg-red-500 rounded-full mt-2 flex-shrink-0"></div>
                        <p className="text-red-900 leading-relaxed text-sm">{rule}</p>
                      </div>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default Chit;